import store from './store';
import router from '@/router';
import { Route, RouteConfig } from 'vue-router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

const routerFiles = require.context('@/routers/', true, /\.(js|ts)$/);
const isArray = (target: any): boolean => Object.prototype.toString.call(target) == '[object Array]';
const isString = (target: any): boolean => Object.prototype.toString.call(target) == '[object String]';
const isObject = (target: any): boolean => Object.prototype.toString.call(target) == '[object Object]';
let configRouters: Array<any> = [];
let configRoutersJson: Array<any> = [];

//递归实现路由文件的融合, 将所有路由文件中的配置合并为一棵路由树;
//注意: 不同路由文件中的相同路由将不会被覆盖, 但是子路由却融合进同一分支;
//例如: /routers/user.ts中定义了path:'/user', children: [ { path: 'info' } ]路由;
//		/routers/system.ts中定义了path: '/user', children: [ { path: 'setting' } ]路由;
//结果: 路由树中将生成path:'/user', children: [ {path:'info'}, {path:'setting'} ]这样的融合树;
//结论: 如果一个大功能块由不同开发者分块开发.可以使用此方案. 正常情况下不建议将子路由分散到不同的配置文件.
const guid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
let loop: any = function (node: RouteConfig | Array<RouteConfig>, root: Array<RouteConfig>) {
  if (isArray(node)) {
    (node as Array<RouteConfig>).forEach(item => {
      return loop(item, root);
    });
    return root;
  }
  let aNode: RouteConfig = node as RouteConfig;
  let aIndex = root.findIndex(item => item.path == aNode.path);

  //给当前目标节点设定guid;
  aNode.meta = aNode.meta || {};
  aNode.meta.guid = guid();

  //给当前目标节点的所有子节点设定guid;
  const mixGUID = (node: RouteConfig) => {
    return (node.children || []).map(item => {
      item.meta = item.meta || {};
      item.meta.guid = guid();
      item.meta.parentid = node.meta.guid;
      item.children = mixGUID(item);
      return item;
    });
  };
  aNode.children = mixGUID(aNode);

  if (aIndex >= 0) {
    //如果当前父级树上已经有与目标节点路径相同的节点时, 认为存在冲突节点;
    //此时先记录你级树上的节点, 后面后将目标节点中没有冲突的子节点合并到父节点中;

    let rootNode = root[aIndex];
    let nodeChildren = aNode.children;
    rootNode.children = rootNode.children || [];
    aNode.children = [];
    if (rootNode.children && rootNode.children.length) {
      if (nodeChildren && nodeChildren.length) {
        nodeChildren.forEach(item => {
          return loop(item, rootNode.children);
        });
      }
    } else {
      if (nodeChildren && nodeChildren.length) {
        rootNode.children = [...nodeChildren];
      }
    }
  } else {
    root.push(aNode);
  }

  return root;
};

const compareWithRole = function (roleTree: Array<any> | any | string) {
  const roleCompare = function (treeA: Array<any>, treeB: Array<any>): Array<any> {
    //优先获取权限系统匹配过滤后的路由树;
    const roleWithService = treeB
      .map(tree => {
        //判断全量路由树中是否有节点匹配当前权限节点, 如果有则认为当前权限节点是有效的;
        //支持权限节点使用表示path的字符串来进行匹配操作;

        let roleNode = null;
        if (isString(tree.path)) {
          roleNode = treeA.find(item => tree.path.toLowerCase() == item.path.toLowerCase());
        } else if (isString(tree)) {
          //如果权限节点是字符串, 则认为是当前路由节点全有效;
          roleNode = treeA.find(item => tree.toLowerCase() == item.path.toLowerCase());
        }
        if (roleNode) {
          roleNode.meta = roleNode.meta || {};
          roleNode.meta.role = roleNode.meta.role || true;
          //有效权限节点, 此时优先使用权限节点的title属性, 次优先使用路由节点本身的title属性;
          roleNode.meta.title = tree.title || roleNode.meta.title || '';
          return roleNode;
        }

        //无效节点返回Null以便被后面的filter函数过滤掉;
        return null;
      })
      .filter(node => !!node);
    //次优先获取没有在权限系统中出现的路由节点组成的静态路由树;
    const roleWithDefault = treeA.filter(tree => {
      //如果权限路由树匹配到全量路由树中的某个节点, 此时优先级为权限系统, 我们认为此节点为权限节点
      //(即使该节点没有设置role属性值也强制认为是权限结节);
      if (roleWithService.find(item => tree.path.toLowerCase() == item.path.toLowerCase())) {
        return false;
      }
      if (!tree.meta || !(tree.meta && tree.meta.role)) {
        return true; //没有role标签的节点默认认为是有权限的;
      }
      return false;
    });

    //将权限节点放在静态路由树前面, 始终保持权限控制的节点优先级最高;
    const roleList = [...roleWithService, ...roleWithDefault].map(role => {
      const sRoleNode = treeB.find(item => {
        //如果是字符串格式的权限节点, 直接返回该字符串, 后面再次判断如果为字符串就忽略对children进行递归;
        if (isString(item)) return item;
        return role.path.toLowerCase() == item.path.toLowerCase();
      });
      if (isString(sRoleNode)) {
        //如果是字符串格式的权限节点, 则认为其对应的整个路由树有效, 不对它的children进行递归权限处理;
        return role;
      }
      if (role.children && role.children.length && sRoleNode) {
        //如果最终的路由树有children级别, 则循环递归按上面的规则处理children中的子节点;
        role.children = roleCompare(role.children, sRoleNode.children || []);
      }
      return role;
    });
    return roleList;
  };

  let routes: Array<any> = [];
  if (isObject(roleTree)) {
    routes = roleCompare(configRouters, [roleTree]);
    //注册单个路由;
  } else if (isString(roleTree) && roleTree === '*') {
    routes = [...configRouters];
    //注册全部路由;
  } else if (isArray(roleTree)) {
    routes = roleCompare(configRouters, roleTree);
    //注册过滤权限后的路由;
  }

  (router as any).options = (router as any).options || {};
  (router as any).options.routes = (router as any).options.routes || [];

  let page404: any = null;
  routes = routes
    .map((route: any) => {
      //过滤掉已经存在的路由, 避免重复注册相同的路由;
      if (route.path == '*' && !(router as any).options.routes.find((route: any) => route.path == '*')) {
        page404 = route;
        return null;
      }
      if (!(router as any).options.routes.find((r: any) => r.path === route.path)) {
        return route;
      }
      return null;
    })
    .filter((route: any) => !!route);
  routes = page404 ? [...routes, page404] : routes;

  router.addRoutes(routes);
  (router as any).options.routes.push(...routes);
};

//暴露给window用来自动生成权限树列表文件;
(window as any).getRoleFile = function () {
  const checkRole = (node: any) => {
    const child = (node.children || []).find((item: any) => item.meta && item.meta.role);
    if ((node.meta && node.meta.role) || child) {
      return true;
    }
    return false;
  };
  const loop = (list: Array<any>) => {
    return list
      .map(route => {
        if (checkRole(route)) {
          let roleNode = {
            nameCn: (route.meta || {}).title || '',
            path: route.path,
          };
          if ((route.meta || {}).icon) {
            (roleNode as any).extend = JSON.stringify({
              icon: (route.meta || {}).icon,
            });
          }

          if (route.children && route.children.length) {
            const aChidlren = loop(route.children);
            if (aChidlren && aChidlren.length) {
              (roleNode as any).childList = aChidlren;
            }
          }
          return roleNode;
        }
        return null;
      })
      .filter(node => !!node);
  };

  var urlObject = (window as any).URL || (window as any).webkitURL || window;
  var downloadData = new Blob([JSON.stringify(loop(configRoutersJson), null, 4)]);
  var save_link: HTMLElement = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
  (save_link as any).href = urlObject.createObjectURL(downloadData);
  (save_link as any).download = 'role.txt';
  var save_event = document.createEvent('MouseEvents');
  save_event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
  (save_link as any).dispatchEvent(save_event);
};

routerFiles.keys().forEach(key => {
  //添加所有路由文件数组中的配置到configRouters数组中;
  //configRouters = configRouters.concat(routerFiles(key).default); // 读取出文件中的default模块
  configRouters = loop(routerFiles(key).default, configRouters);
});
//备份下原始的routers数组, 在getRoleFile方法中会用到;
configRoutersJson = JSON.parse(JSON.stringify(configRouters));

let routerInit: boolean = false;
let routerDefault: string = '';
export function init() {
  //console.log('初始化路由守卫功能!');

  if (routerInit) return;
  routerInit = true;
  router.beforeEach(async (to: Route, from: Route, next: any) => {
    NProgress.start();

    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!router.app.$global.token) {
        //本来可以在这里通过handler将问题抛出给开发者解决;
        //思考后我认为开发者应该遵守规范在role或其它action里将token(写入全局变量)与用户信息存起来;
        //这样的话解决方案就是标准方案, 功能更单一更容易处理;
        //注意: 在进入有授权限制的路由之前, 一定要将token写入到全局变量中, 哪怕是假的token都可以;
        console.warn('请使用router.app.$global.set("token", value)设置全局token!');
        return;
      }
      next();
      return;
    }

    const routes = ((router as any).options || { routes: [] }).routes || [];
    if (!routes.length) {
      const role: any = await store.dispatch('role');
      let roleTree: Array<any> | string = role.routes || role;
      routerDefault = role.default;

      if (isArray(roleTree) || roleTree == '*') {
        compareWithRole(roleTree);
      } else if (isString(roleTree)) {
        compareWithRole([roleTree]);
      }
      //console.log('获取到权限系统的返回值!', roleTree);
      router.app.$nextTick(() => {
        //console.log('成功注册路由, 现在跳转到之前记录的要跳转到的路由!');
        next({ ...to, replace: true });
      });
      return;
    }
    next();
  });
  router.afterEach((to: Route, from: Route): any => {
    if (!router.app.$route.matched.length) {
      if (routerDefault) {
        router.replace(routerDefault);
      } else {
        const routes = ((router as any).options || { routes: [] }).routes || [];
        if (routes.length) {
          router.replace(routes[0]);
        }
      }
    }
    router.app.$nextTick(() => {
      NProgress.done();
    });
  });
}

export default router;
